// Client-side JWT payload parser — used ONLY for app_role routing decisions.
// Server endpoints re-verify the JWT signature; this helper is informational.

export const parseJwt = <T = Record<string, unknown>>(token: string): T => {
  try {
    const parts = token.split(".");
    if (parts.length < 2) throw new Error("malformed JWT");
    const payload = parts[1]!;
    // base64url -> base64
    const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    const json =
      typeof atob === "function"
        ? atob(padded)
        : Buffer.from(padded, "base64").toString("utf-8");
    return JSON.parse(json) as T;
  } catch {
    return {} as T;
  }
};
